import { render, staticRenderFns } from "./_base-customer-modal.vue?vue&type=template&id=2f4ad49f&scoped=true"
import script from "./_base-customer-modal.vue?vue&type=script&lang=js"
export * from "./_base-customer-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-customer-modal.vue?vue&type=style&index=0&id=2f4ad49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ad49f",
  null
  
)

export default component.exports